import { EventStatusPipe } from './event.status.pipe';

export function EventStatusFilter ( eventStatusPipe : EventStatusPipe ) {
  return ( value : string ) : string => eventStatusPipe.transform(value);
}